import { useEffect, useState } from 'react'
import { Autocomplete, useJsApiLoader } from '@react-google-maps/api'
import { formatAdressSeachGoogleMapa } from '../../../pages/explorer/components/common'
import { googleMapsLoaderOptions } from '../../../utils/googleMapsLoader'

export function AutocompleteGoogle({ onChangeAddress,endereco }) {
  const [enderecoBusca, setEnderecoBusca] = useState('')
  const { isLoaded, loadError } = useJsApiLoader(googleMapsLoaderOptions)
  
  useEffect(() => {
    setEnderecoBusca(endereco ?? '')
  },[endereco])

  const [searchResult, setSearchResult] = useState(null)

  function onLoadAutocomplete(autocomplete) {
    setSearchResult(autocomplete)
  }

  function onPlaceChanged() {
    if (searchResult != null) {
      const enderecoFormatado = formatAdressSeachGoogleMapa(searchResult.getPlace())
      onChangeAddress(enderecoFormatado)
    }
  }

  return (
    <>
      {loadError ? (
        ''
      ) : isLoaded ? (
        <>
          <Autocomplete onLoad={onLoadAutocomplete} onPlaceChanged={onPlaceChanged}>
            <input
              type='text'
              placeholder='Buscar Endereço'
              className='form-control form-control-solid'
              value={enderecoBusca}
              onChange={(e)=>{setEnderecoBusca(e.target.value)} }
            />
          </Autocomplete>
        </>
      ) : (
        ''
      )}
    </>
  )
}
